// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@4.3.0_webpack@5.104.1_webpack-cli@6.0.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ant-card-bordered {\n  flex: auto;\n  margin: 10px;\n}\n.ant-card-bordered:first-child .ant-select {\n  width: 100%;\n}\n.demo-page > .ant-card {\n  margin: 2rem;\n}\n.learning-everywhere.red a {\n  color: red;\n}\n.learning-everywhere.large a {\n  font-size: large;\n}\n.learning-everywhere.gray {\n  background-color: lightgrey;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
